if (navigator.userAgent.indexOf('Android') > -1) {
  document.documentElement.classList.add('t-android');
}

var button = document.querySelector('.js-overlay-menu-button');
var overlayMenu = document.querySelector('.js-overlay-menu');

var setUpPreviews = require('./_components.project-preview.js');
var setUpScroller = require('./_components.project-scroller.js');

if (button && overlayMenu) {
  setUpPreviews();
  var updateScrollerPosition = setUpScroller();

  var transitioning = false;
  var expanded = false;

  function toggleMenu() {
    if (!transitioning) {
      transitioning = true;

      if (expanded) {
        hideMenu();
      } else {
        showMenu();
      }
    }
  }

  function hideMenu() {
    document.body.classList.add('menu-is-offscreen');
    document.body.classList.add('menu-is-transitioning');
    expanded = false;
    document.body.classList.remove('menu-is-open');

    overlayMenu.addEventListener('transitionend', function onHidden(event) {
      if (event.propertyName == 'opacity') {
        transitioning = false;
        document.body.classList.add('menu-is-inactive');
        overlayMenu.removeEventListener('transitionend', onHidden);
        button.setAttribute('aria-expanded', false);
        document.body.classList.remove('menu-is-active');
        document.body.classList.remove('menu-is-transitioning');
      }
    });
  }

  function showMenu() {
    document.body.classList.remove('menu-is-inactive');
    document.body.classList.add('menu-is-transitioning');
    button.classList.add('menu-is-open');
    window.scroll({
      top: 0,
      behavior: 'smooth'
    });
    updateScrollerPosition();

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        document.body.classList.remove('menu-is-offscreen');
        button.setAttribute('aria-expanded', true);
        document.body.classList.add('menu-is-active');
        expanded = true;

        overlayMenu.addEventListener('transitionend', function onShown(event) {
          if (event.propertyName == 'opacity') {
            transitioning = false;
            overlayMenu.removeEventListener('transitionend', onShown);
            document.body.classList.remove('menu-is-transitioning');
          }
        });
      });
    });
  }

  button.addEventListener('click', toggleMenu);
}
